import Request from "./request";

// 当前库位
async function fetch(data) {
  return Request("get", "api/position-activities/", data);
}


// async function fetchOne(id,data) {// 获取单个
//     return Request('get', "api/position-activities/" + id, data);
// }

export default {
  fetch,
//   fetchOne,
};
